import XIcon from '@elementor/icons/XIcon';
import Box from '@elementor/ui/Box';
import Button from '@elementor/ui/Button';
import IconButton from '@elementor/ui/IconButton';
import Infotip from '@elementor/ui/Infotip';
import Typography from '@elementor/ui/Typography';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { uxMessaging } from '@constants/ux-messaging';
import {
	StyledInfoTipBox,
	StyledInfoTipFooter,
	StyledExampleLink,
} from '@styles/manual-fixes.styles';
import { __ } from '@utils/i18n';

const IssueResolveExampleLink = ({ ruleId }) => {
	const [openExample, setOpenExample] = useState(false);

	const closeExample = () => setOpenExample(false);

	const handleLinkClick = (e) => {
		e.preventDefault();
		setOpenExample(true);
	};

	return (
		<Infotip
			arrow
			placement="left"
			onClose={closeExample}
			open={openExample}
			PopperProps={{
				disablePortal: true,
			}}
			disableFocusListener
			disableHoverListener
			disableTouchListener
			content={
				<StyledInfoTipBox>
					<Box display="flex" justifyContent="space-between" alignItems="start">
						<Typography variant="subtitle1" as="h5" sx={{ mb: 3 }}>
							{__('See an example')}
						</Typography>

						<IconButton
							onClick={closeExample}
							aria-label={__('Close tooltip')}
							size="small"
							edge="end"
							sx={{ mt: -1 }}
						>
							<XIcon />
						</IconButton>
					</Box>

					<Typography variant="subtitle2" as="h6">
						{__('Issue:')}
					</Typography>

					<Typography variant="body2" color="secondary" sx={{ mb: 2 }}>
						{uxMessaging[ruleId].seeAnExample.issue}
					</Typography>

					<Typography variant="subtitle2" as="h6">
						{__('Resolution:')}
					</Typography>

					{uxMessaging[ruleId].seeAnExample.resolution.flatMap(
						(resolution, index) => (
							<Typography
								variant="body2"
								color="secondary"
								key={`resolution-${index}`}
								sx={{ mb: 2 }}
							>
								{resolution}
							</Typography>
						),
					)}

					<StyledInfoTipFooter>
						<Button
							size="small"
							color="info"
							variant="contained"
							onClick={closeExample}
						>
							{__('Got it')}
						</Button>
					</StyledInfoTipFooter>
				</StyledInfoTipBox>
			}
		>
			<StyledExampleLink
				size="small"
				color="info"
				variant="text"
				onClick={handleLinkClick}
			>
				{__('See an example')}
			</StyledExampleLink>
		</Infotip>
	);
};

IssueResolveExampleLink.propTypes = {
	ruleId: PropTypes.string.isRequired,
};

export default IssueResolveExampleLink;
